import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles, Play } from "lucide-react";
// LazyImage removed - using standard img for LCP optimization
import TrustStrip from "@/components/marketing/TrustStrip";
import heroDashboard from "@/assets/hero-dashboard.png";
import ProblemPromise from "@/components/marketing/ProblemPromise";
import ValueProposition from "@/components/marketing/ValueProposition";
import HowItWorks from "@/components/marketing/HowItWorks";
import ModulesShowcase from "@/components/marketing/ModulesShowcase";
import AICoFounderStrip from "@/components/marketing/AICoFounderStrip";
import PersonaCards from "@/components/marketing/PersonaCards";
import PricingTeaser from "@/components/marketing/PricingTeaser";
import CreditsFAQ from "@/components/marketing/CreditsFAQ";
const HomePage = () => {
  return <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-20 md:py-32 bg-gradient-to-br from-background via-background to-primary/5">
        {/* Subtle gradient orbs for depth */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-3xl opacity-20" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent/10 rounded-full blur-3xl opacity-20" />
        
        <div className="container max-w-7xl mx-auto px-4 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Left: Text Content */}
            <div className="space-y-8 text-center lg:text-left">
              {/* Eyebrow */}
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 backdrop-blur-sm">
                <Sparkles className="h-4 w-4 text-primary" />
                <span className="text-sm font-semibold uppercase tracking-wide text-primary">
                  Unified Freelancer Productivity OS
                </span>
              </div>

              {/* Headline */}
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-tight">
                Run your entire freelance business from one place.
              </h1>

              {/* Sub-headline */}
              <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed">
                Catlyo brings your clients, tasks, finance, and AI insights into one seamless workspace.
              </p>

              {/* CTAs */}
              <div className="flex-col lg:items-start gap-4 pt-4 flex items-center justify-center sm:flex sm:flex-row">
                <Button asChild size="lg" className="text-base px-8 shadow-lg hover:shadow-xl transition-all">
                  <Link to="/auth">
                    Start Free
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </Button>
                <Button asChild size="lg" variant="outline" className="text-base px-8 border-2">
                  <Link to="/contact?type=demo">
                    <Play className="mr-2 h-5 w-5" />
                    Watch Demo
                  </Link>
                </Button>
              </div>

              {/* Micro-copy */}
              <p className="text-sm text-muted-foreground pt-2">
                Free to start. No credit card needed.
              </p>
            </div>

            {/* Right: Floating Dashboard Mockup */}
            <div className="relative lg:block hidden">
              <div className="relative animate-fade-in">
                {/* Glow effect behind image */}
                <div className="absolute inset-0 bg-primary/20 rounded-3xl blur-3xl scale-95" />
                
                {/* Dashboard image with eager loading and high priority for LCP */}
                <img src={heroDashboard} alt="Catlyo Dashboard Interface" className="relative rounded-2xl shadow-2xl hover:scale-105 transition-transform duration-500 ease-out opacity-100" fetchPriority="high" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. Trust Strip */}
      <TrustStrip />

      {/* 3. Problem → Promise */}
      <ProblemPromise />

      {/* 4. Value Proposition - 4 Cards */}
      <ValueProposition />

      {/* 5. How It Works - 3 Steps */}
      <HowItWorks />

      {/* 6. Modules Overview - 9 Modules */}
      <ModulesShowcase />

      {/* 7. AI Co-Founder Strip */}
      <AICoFounderStrip />

      {/* 8. Who It's For - 4 Personas */}
      <PersonaCards />

      {/* 9. Pricing Teaser */}
      <PricingTeaser />

      {/* 10. Credits FAQ */}
      <CreditsFAQ />

      {/* 11. Final CTA Section */}
      <section className="py-20 md:py-32 bg-gradient-to-b from-muted/30 to-background">
        <div className="container max-w-5xl mx-auto px-4">
          <div className="text-center space-y-8">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold">
              Give your freelance business the OS it deserves.
            </h2>
            
            <p className="text-xl text-muted-foreground leading-relaxed max-w-3xl mx-auto">
              See your money, work, and priorities in one place — with an AI co-founder that keeps you 
              moving toward your goals.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
              <Button asChild size="lg" className="text-base px-8">
                <Link to="/auth">
                  Start Free
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="text-base px-8">
                <Link to="/contact?type=demo">Book a Demo</Link>
              </Button>
            </div>

            <p className="text-sm text-muted-foreground pt-4">
              Start in minutes. Keep your existing tools until you're ready to move fully into Catlyo.
            </p>
          </div>
        </div>
      </section>
    </div>;
};
export default HomePage;